export default __webpack_public_path__ + "static/media/img_suopu.24c3d196.png";